import zhCN from './json/tuwen.zh_CN.json';
import zhTW from './json/tuwen.zh_TW.json';
import en from './json/tuwen.en.json';
import ja from './json/tuwen.ja.json';
import ko from './json/tuwen.ko.json';
import ru from './json/tuwen.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
